import { render, staticRenderFns } from "./MenuSuperAdmin.vue?vue&type=template&id=4e443749&scoped=true&"
import script from "./MenuSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./MenuSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e443749",
  null
  
)

export default component.exports